import { toReadableTimestamp } from "../../utils/orderUtils";
import React, { useState, useEffect } from "react";

export default function OrderDelivery({order}) {
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!order) return null;

        const trackedItems = order.items.filter(item => item.tracking);
        setItems(trackedItems);
    }, []);

    return (
        <div>
            <div className="table-container">
                <table className="table">
                    <tbody>
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Shipping Level
                            </td>
                            <td style={{ color: 'var(--text-secondary)' }}>
                                {order.shipping.estimated_delivery.level}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Carrier Service
                            </td>
                            <td style={{ color: 'var(--text-secondary)' }}>
                                {order.shipping.estimated_delivery.carrier_service_name}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Min Delivery Date
                            </td>
                            <td style={{ color: 'var(--text-secondary)' }}>
                                {toReadableTimestamp(order.shipping.estimated_delivery.min_delivery_date)}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ 
                                fontWeight: 'var(--font-weight-semibold)', 
                                color: 'var(--text-primary)',
                                paddingRight: 'var(--spacing-xl)',
                                minWidth: '150px'
                            }}>
                                Max Delivery Date
                            </td>
                            <td style={{ color: 'var(--text-secondary)' }}>
                                {toReadableTimestamp(order.shipping.estimated_delivery.max_delivery_date)}
                            </td>
                        </tr>
                        { items.length > 0 && (
                            <>
                                <tr>
                                    <td style={{ 
                                        fontWeight: 'var(--font-weight-semibold)', 
                                        color: 'var(--text-primary)',
                                        paddingRight: 'var(--spacing-xl)',
                                        minWidth: '150px'
                                    }}>
                                        Tracking Number
                                    </td>
                                    <td style={{ 
                                        fontFamily: 'var(--font-family-mono)', 
                                        fontWeight: 'var(--font-weight-medium)',
                                        color: 'var(--text-secondary)'
                                    }}>
                                        {items[0]['tracking']['tracking_id']}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ 
                                        fontWeight: 'var(--font-weight-semibold)', 
                                        color: 'var(--text-primary)',
                                        paddingRight: 'var(--spacing-xl)',
                                        minWidth: '150px'
                                    }}>
                                        Tracking URL
                                    </td>
                                    <td>
                                        <a 
                                            href={items[0]['tracking']['tracking_url']} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{ color: 'var(--primary-color)' }}
                                        >
                                            {items[0]['tracking']['tracking_url']}
                                        </a>
                                    </td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}